<template>
  <section class="age-gate">
    <div class="candy-bar" />

    <form @submit="verifyAge">
      <div class="age-gate-banner" @click="bannerClicked" />

      <h2>You must be<br>13 or older to play</h2>

      <div class="date-select">
        <CJSelectBox v-model="month"
                     :options="monthOptions"
                     placeholder="MM" />

        <CJSelectBox v-model="day"
                     :options="dayOptions"
                     placeholder="DD" />

        <CJSelectBox v-model="year"
                     :options="yearOptions"
                     placeholder="YYYY" />
      </div>

      <CJButton type="submit" :disabled="!birthday">Enter</CJButton>
    </form>

    <CJModal :show="showModal">
      <CJPopup class="thirteen" @dismiss="showModal = false">
        <h3>Looks like you<br>aren't 13 yet!</h3>
        <p>Come back in {{ thirteenthYear }} to play!</p>
      </CJPopup>
    </CJModal>
  </section>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { range, reverse } from 'ramda'
import moment from 'moment'

import CJButton from '@/components/CJButton'
import CJSelectBox from '@/components/CJSelectBox'
import CJModal from '@/components/CJModal'
import CJPopup from '@/components/CJPopup'

export default {
  name: 'AgeGate',

  components: { CJButton, CJSelectBox, CJModal, CJPopup },

  data () {
    return {
      month: null,
      day: null,
      year: null,
      dayOptions: range(1, 32),
      yearOptions: reverse(range(1900, moment().year() + 1)),
      monthOptions: range(1, 13),
      showModal: false,
    }
  },

  computed: {
    ...mapGetters([ 'isDevEnv' ]),

    /** @returns {moment.Moment} */
    birthday () {
      return !this.month || !this.day || !this.year
        ? null
        : moment()
          .month(this.month - 1)
          .date(this.day)
          .year(this.year)
    },

    /** @returns {Boolean} */
    isAtLeast13 () {
      if (!this.birthday) return false
      return moment() >= moment(this.birthday).add(13, 'years')
    },

    /** @returns {String} */
    thirteenthYear () {
      return moment(this.birthday).add(13, 'years').format('YYYY')
    },
  },

  methods: {
    /** @param {Event} event */
    updateBirthday (event) {
      /** @type {HTMLInputElement} */
      const $date = event.currentTarget

      this.birthday = $date.value
        ? moment($date.value, 'YYYY-MM-DD')
        : null
    },

    /** @param {Event} event */
    verifyAge (event) {
      event.preventDefault()

      if (!this.isAtLeast13) {
        this.showModal = true
      } else {
        this.$store.commit('setIsAtLeast13', true)
        this.$router.replace(this.$route.params.redirect || '/')
        Vue.$bus.emit('age-confirmed')
      }
    },

    bannerClicked () {
      if (!this.isDevEnv) return

      this.month = 1
      this.day = 1
      this.year = 2005
    },
  },
}
</script>

<style lang="stylus" scoped>
  .age-gate
    form
      display: flex
      flex-direction: column
      align-items: center

      .age-gate-banner
        margin: -18px 0 18px

      .date-select
        display: flex
        transform: translateX(-1px)

        .cj-select-box
          margin: 0 -5px 0 0

      h2
        margin: 0 0 18px
        text-align: center
        text-transform: uppercase
        font-weight: 800
        font-size: 24px
        font-family: 'Futura Std Condensed'

  .cj-popup.thirteen
    left: calc(50% - 2px)
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    color: #1a294a
    padding: 28px
    box-sizing: border-box

    h3
      margin: 0 0 14px
      text-align: center
      text-transform: uppercase
      font-weight: 700
      font-size: 30px
      font-family: 'Futura Std Condensed'

    p
      margin: 0
      text-align: center
      font-weight: 700
      font-size: 24px
      font-family: 'Futura Std Condensed'
</style>
